import { useMemo } from 'react';
import { zeroPad } from 'react-countdown';
import { useTranslation } from 'react-i18next';

import { ModularCard } from '@/components/ui/custom/modular/ModularCard';
import useToggle from '@/data/hook/useToggle';
import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import LessonDetail from './LessonDetail';
import { getPreviousBlocksLessons } from '../matrix/CourseStudioLessons.hooks';
import { StudioPermissions } from '@/enums/VersioningStatus';

type Props = {
  block: TempLessonBlock;
  blockIndex: number;
  blocks?: TempLessonBlock[];
  studioPermissions: StudioPermissions;
  coursePathId?: number;
  loading?: boolean;
};

export default function LessonBlockDetail(props: Props) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseStudio',
  });

  const {
    block,
    blockIndex,
    blocks = [],
    studioPermissions,
    coursePathId,
    loading,
  } = props;

  const { isOpen, toggle } = useToggle(true);

  const blockName = useMemo(() => {
    return `${t('block', { index: zeroPad(blockIndex + 1, 2) })} - ${
      block.name
    }`;
  }, [block.name, blockIndex, t]);

  return (
    <li>
      <ModularCard className={{ base: 'shadow-none border-none' }}>
        <ModularCard.Header
          title={blockName}
          onOpen={toggle}
          isOpen={isOpen}
          className={{ title: 'text-primary', button: 'text-primary' }}
        />

        <ModularCard.Accordion isOpen={isOpen} className={{ base: 'px-4' }}>
          <ul className="flex flex-col gap-2.5 pb-3.5">
            {block.lessons.map((lesson, lessonIndex) => {
              const previousBlocksLessons = getPreviousBlocksLessons(
                blockIndex,
                blocks,
              );

              return (
                <LessonDetail
                  key={lesson.id || lesson.tempId}
                  lesson={lesson}
                  blockIndex={blockIndex}
                  lessonIndex={lessonIndex}
                  globalLessonIndex={previousBlocksLessons + lessonIndex}
                  studioPermissions={studioPermissions}
                  coursePathId={coursePathId}
                  loading={loading}
                />
              );
            })}
          </ul>
        </ModularCard.Accordion>
      </ModularCard>
    </li>
  );
}
